module.exports = {
  "FoodB_manager_Kwwl_Cjll": "Desde el día 8 hasta el final del programa, invierte entre {{amount1}} y {{amount2}} para obtener una recompensa de la plataforma del {{rate1}}.",
  "FoodB_manager_jhXU_ptlV": "Total de veces que se hizo clic en tu anuncio",
  "FoodB_manager_OKSu_qWyl": "No está permitido realizar modificaciones durante el periodo de vigencia de las recompensas; esta opción estará disponible cuando el evento finalice el {{end_data}}",
  "FoodB_images_tgoc_AhLQ": "Disponible",
  "FoodB_Overview_AasD_LvfW": "Ver más",
  "FoodB_manager_sgsH_EpiM": "día",
  "FoodB_manager_HqjV_CxOA": "Tu presupuesto no cumple con los requisitos de la promoción. Te recomendamos agregar presupuesto para acceder a las promociones",
  "FoodB_manager_ntwn_wBNk": "Impresiones del anuncio",
  "FoodB_images_qpuG_DTcO": "Baja calidad",
  "FoodB_manager_aCSR_lQaQ": "semana",
  "FoodB_modification_Confirmation_ehVU": "Confirmar",
  "FoodB_guidance_ympr_VDEB": "15% de dto.",
  "FoodB_V_Cancel_ELKJ": "Cancelar",
  "FoodB_ads_PRAv_IxKG": "Este es el monto total que gastaste por este anuncio",
  "FoodB_manager_BMOX_RrUm": "Gratis los primeros 7 días",
  "FoodB_images_zcVM_dgvs": "Sin foto",
  "FoodB_202403_iElx_PrgH": "Se necesita acceso al álbum de fotos. Activa los permisos e inténtalo de nuevo.",
  "FoodB_IOS_bkpb_pDAZ": "Se marcó como no disponible",
  "FoodB_ads_iUsb_wdEa": "Publicar un anuncio",
  "FoodB_ads_JKaI_zpdU": "No se pudo reiniciar",
  "FoodB_optimization_lHJe_wjVZ": "{{num}} vendido(s) por mes",
  "FoodB_structure_Next_step_GKKZ": "Siguiente",
  "FoodB_202403_tIbT_QIhv": "Descargado correctamente",
  "FoodB_structure_If_the_qaXe": "Si este producto es una parte obligatoria de cualquiera de los siguientes productos, marcarlo como no disponible hará que también se marquen como no disponibles los otros productos",
  "FoodB_edit_iIzf_VxWT": "Precio del grupo modificador",
  "FoodB_ads_Vuno_mXMy": "Pausar",
  "FoodB_IOS_UOug_fSFt": "Ver menos",
  "FoodB_manager_ZQKX_FOdY": "Gratis desde hoy hasta el {{trail_end_date}}",
  "FoodB_202507_Mmtm_bVsd": "Código de verificación",
  "FoodB_ads_wEEv_oKzi": "Ventas logradas con los anuncios publicados",
  "FoodB_manager_cfaa_kvuC": "Vistas del anuncio",
  "FoodB_ads_AbgR_WCms": "ROI",
  "FoodB_structure_The_group_yaQn": "El grupo modificador {{group_name}} está incompleto y no puede marcarse como disponible. Edítalo e inténtalo de nuevo.",
  "FoodB_ads_fbjh_KkrE": "{{amount}} (compartido entre todas las tiendas que publican un anuncio)",
  "FoodB_b_Merchant_activities_AOMe": "Eventos de promociones",
  "FoodB_ads_kQlR_vLwo": "Preguntas frecuentes",
  "FoodB_edit_Kpjr_ClVJ": "Enviar cambios",
  "FoodB_event_gnlU_HgeW": "Recompensas del Programa",
  "FoodB_signup_Rpjk_VExr": "Marca la casilla para aceptar los T&C",
  "FoodB_structure_Only_the_TlfX": "Marcar este producto como no disponible",
  "FoodB_manager_kgoO_KDWx": "Pedidos a partir del anuncio",
  "FoodB_images_hyZS_lUdA": "Ventas ▲",
  "Gattaran_System_stOW_oOzc": "Editar",
  "FoodB_202507_zUrC_RTLN": "El código de verificación no puede estar vacío",
  "FoodB_guidance_qLuz_cdFT": "Los combos con descuentos del 15% o más pueden participar en campañas promocionales",
  "FoodB_202412_AFEo_IMDT": "Ver",
  "FoodB_images_Odmy_EpkO": "Repetida",
  "FoodB_202507_VtFw_lWoZ": "El código de verificación debe tener seis dígitos",
  "FoodB_end_wXDp_EzMh": "Este campo no puede estar vacío",
  "FoodB_Notification_cXDd_hXys": "Confirmar",
  "FoodB_structure_There_are_IFaR": "Hay más de un producto con el mismo nombre. Elige qué productos marcar como no disponibles",
  "FoodB_ads_eLJV_rpQs": "Se reanudó correctamente",
  "FoodB_images_SJsQ_RTPC": "Fija",
  "FoodB_202507_Kvbw_JjQU": "La invitación venció. Por favor, ponte en contacto con la tienda para obtener una nueva",
  "FoodB_ads_LYLE_IJlq": "Términos y Condiciones de Anuncios",
  "FoodB_ads_JrZk_DAPd": "Crear mi plan de anuncios",
  "FoodB_end_tShf_yvRL": "Ingresar",
  "soda-b-web-i18n---必选": "Obligatorio",
  "FoodB_202507_pyLz_EIhG": "Verificar y continuar",
  "FoodB_raise_GzoV_LxqP": "No se pudo cambiar el precio de uno o más productos. Por favor, revisa los detalles en la app de {{sys}}.",
  "FoodB_end_jDIn_MChP": "Nombre de la tienda",
  "FoodB_IOS_aPdf_nqLr": "Estado de la imagen",
  "FoodB_ads_dOkB_VPYp": "Tiendas para la publicación de anuncios",
  "FoodB_Subscribe202412_zlrO_JCcA": "Atención",
  "FoodB_20240530_DIPS_Umqk": "Entendido",
  "FoodB_Refund_VgKI_KAdX": "Nombre del producto",
  "FoodB_structure_Remove_items_mzeF": "Marcar todos los productos con el mismo nombre (incluyendo subproductos) como no disponibles",
  "FoodB_20220201_Confirmation_uFDW": "Confirmar",
  "FoodB_manager_dbWL_uoLT": "Total de veces que se vio tu anuncio",
  "FoodB_202507_AaJV_ONrK": "Descargar",
  "FoodB_202507_eldX_PSOm": "Reenviar",
  "FoodB_examination_RLMB_cTnU": "Este producto no se puede vender debido a que su precio es más alto que el precio del menú físico o de otra plataforma. Por favor, modifica los precios del producto y del modificador para que sean más bajos que los precios del menú físico o de otra plataforma, y luego vuelve a marcar el producto como disponible.",
  "FoodB_images_elYf_pCKJ": "Agregar",
  "FoodB_manager_KMon_Ucmi": "Recompensa de hasta un {{{max_rate}}} después",
  "FoodB_manager_Pmbs_CYnh": "Participa en la promoción para obtener un total de {{amount}} días de recompensas para anuncios. Los primeros 7 días de publicidad de tu tienda son gratuitos",
  "FoodB_examination_jQot_WFxD": "Productos con precios más altos temporalmente eliminados",
  "FoodB_lines__item_gLep": "No se puede cambiar la disponibilidad de {{item}}. Motivo:",
  "FoodB_ads_kkCY_VhnR": "Detalles del anuncio",
  "FoodB_diagnosis_Add_the_ROcc": "Especifica para cuántas personas es el combo",
  "FoodB_images_NRvd_CfNM": "Ubicación del producto",
  "FoodB_images_kqnL_zpUk": "Las imágenes de buena calidad pueden hacer que los usuarios realicen más pedidos.",
  "FoodB_manager_rzAQ_djgI": "Desde el {{start_data}} hasta el {{end_data}}, la plataforma cubre {{p_budget}}/día y la tienda cubre {{b_budget}}/día",
  "FoodB_manager_HaIz_XbUw": "Puedes ver las ganancias del anuncio y más información en la página “Detalles del anuncio”",
  "FoodB_IOS_uqRa_ZgjI": "Se marcó como disponible",
  "FoodB_manager_SKhT_KcPn": "Presupuesto para el anuncio",
  "FoodB_structure_This_item_Kjzb": "Este producto está en los grupos modificadores del siguiente producto. Marcarlo como no disponible hará que también se marque como no disponible en los siguientes grupos modificadores",
  "FoodB_manager_ZTpO_CxTr": "Desde hoy hasta el {{end_data}}, la plataforma cubre {{p_budget}}/semana y la tienda cubre {{b_budget}}/semana",
  "FoodB_IOS_GAPD_nKPg": "Estado de las ventas",
  "FoodB_images_Ifqh_ZbIZ": "Todos",
  "FoodB_end_btsz_MEkI": "Registro de acciones",
  "FoodB_ads_GmKW_brRz": "Este es el total de ventas generadas por usuarios que realizaron pedidos en un plazo de siete días después de ver tu anuncio.",
  "FoodB_202403_GUuf_Hxvh": "DiDi Tu Negocio",
  "FoodB_edit_FUgf_iAPR": "Error del sistema. Inténtalo de nuevo.",
  "FoodB_images_Ruvq_UOGP": "Ventas ▼",
  "FoodB_ads_hsyI_CluZ": "Gastos de anuncios",
  "FoodB_images_sDvo_WhBT": "Los productos que no tienen imágenes o que tienen imágenes repetidas no podrán participar en las promociones que se muestran a continuación, lo que podría afectar su visibilidad.",
  "FoodB_edit_EauY_eVbs": "No pueden cambiarse los precios de los productos incluidos en combos o promociones",
  "FoodB_ads_EUKq_wQqg": "Personalizado",
  "FoodB_3_Meij_rAcc": "Sin resultados",
  "FoodB_manager_jDsw_neeZ": "El presupuesto total para anuncios con la recompensa es de {{total_amount}} por día",
  "FoodB_manager_PNYI_bdhw": "Por favor, haz clic {en la parte superior izquierda de la página} para regresar a la lista",
  "FoodB_manager_QWyb_fTPV": "Una vez que la recompensa finalice el {{date}}, el presupuesto para anuncios volverá a ser de {{b_budget}} por semana",
  "FoodB_diagnosis_Fill_in_izgd": "Ingresa la descripción del producto",
  "FoodB_manager_lrhZ_GgWG": "Desde el {{start_data}} hasta el {{end_data}}, la plataforma cubre {{p_budget}}/semana y la tienda cubre {{b_budget}}/semana",
  "FoodB_manager_Vavg_QJRU": "Desde hoy hasta el {{end_data}}, la plataforma cubre {{p_budget}}/día y la tienda cubre {{b_budget}}/día",
  "FoodB_ads_mCxj_GQTc": "Costo (costo por cada clic de usuario)",
  "FoodB_202311_BGpD_RoKX": "No hay más",
  "FoodB_Brazil_ajzJ_JuVl": "En el modelo de franquicia de marca, no tienes permiso para realizar esta acción. Para continuar, por favor, comunícate con el asesor.",
  "FoodB_images_dCkE_owJP": "Las imágenes repetidas pueden reducir la visibilidad de los productos y resultar en menos pedidos.",
  "FoodB_list_pycq_NFTr": "Ver más",
  "FoodB_guidance_KjqW_ZOOL": "Los descuentos del 20 % o más pueden aumentar la posibilidad de mejorar las ventas de los combos",
  "soda-b-web-i18n---可选": "Opcional",
  "FoodB_202507_IeTZ_IsVt": "Código de verificación no válido. Por favor, intenta de nuevo",
  "FoodB_list_RMhg_oxdJ": "Ver menos",
  "soda-b-web-i18n---请输入价格": "Ingresa el precio",
  "FoodB_202507_TYLB_oGxx": "Crea tu cuenta de repartidor",
  "FoodB_manager_tfuO_mmOQ": "Invierte {{amount3}} o más, y obtén una recompensa de la plataforma del {{rate3}}",
  "FoodB_ads_Mhsz_vxcz": "Pausar el anuncio podría reducir la visibilidad de tu tienda en la aplicación, lo que podría afectar tus pedidos.",
  "FoodB_structure_Available_items_YZlI": "Marcar producto como disponible",
  "FoodB_manager_UQMz_EKvg": "Clics en el anuncio",
  "soda-b-web-i18n---请选择": "Seleccionar",
  "FoodB_structure_Confirmation_KdZD": "Confirmar",
  "FoodB_202507_lSPc_azJu": "¡Hola! {{nick_name}} te invita a realizar entregas para {{store_name}}.",
  "FoodB_images_dkwU_DozC": "Quitar",
  "FoodB_ads_xHIG_ssdt": "Usuarios objetivo",
  "FoodB_ads_jnGH_TBtE": "Última actualización el {{date}}",
  "FoodB_manager_dbGg_urLm": "Guardar cambios",
  "FoodB_ads_EuaQ_gUWs": "Presupuesto semanal",
  "FoodB_end_vWCI_Khdj": "ID de la tienda",
  "FoodB_manager_cYvu_RUOJ": "El gasto diario promedio en una semana. El gasto semanal total tiene un límite de siete veces el presupuesto diario.",
  "FoodB_menu_ezpD_HgJQ": "Entrega",
  "FoodB_manager_Zkso_jGUU": "El presupuesto total para anuncios con la recompensa es de {{total_amount}} por semana",
  "FoodB_guidance_KPTM_jtce": "30% de dto.",
  "FoodB_Management_ETTC_atmq": "Aviso",
  "FoodB_202507_KAIz_QuzG": "Después de descargar e instalar la aplicación, inicia sesión con el número de celular verificado y comienza a usar la app.",
  "FoodB_ads_SKdz_cIQv": "Estas son las ganancias de las ventas que recibiste por cada {{amount}} en gastos de anuncios. Este monto se calcula al dividir las ventas del anuncio entre el monto que invertiste en él.",
  "FoodB_202403_Oupx_AERj": "Hubo un error. Intenta descargarlo de nuevo.",
  "FoodB_ads_fFZs_fhfw": "¿Confirmas que quieres pausar el anuncio?",
  "FoodB_one_Create_categories_NYkB": "Crea una categoría primero",
  "FoodB_202507_pnqc_SLIH": "¡Verificación de {{number}} completada con éxito!",
  "FoodB_ads_ohud_CQNg": "Reanudar",
  "FoodB_manager_Taew_Vhya": "La cantidad total de usuarios que vieron el anuncio",
  "FoodB_record_aMyR_GHwi": "Crear",
  "FoodB_ads_TBRW_mcgC": "Ver",
  "FoodB_guidance_TyKs_OJEe": "El precio no puede ser 0",
  "Gattaran_app_wQyy_gBIH": "Esta función solo está disponible en la aplicación de la Tienda y actualmente no es compatible con {{app}}",
  "FoodB_ads_aBTZ_puGq": "Tus planes de anuncios",
  "FoodB_manager_pkmQ_slMM": "Registrado con éxito",
  "FoodB_edit_OzpO_pQjy": "Editar producto",
  "FoodB_structure_Dishes_off_DpDW": "Marcar el producto como no disponible",
  "FoodB_manager_bfcy_TuLs": "El monto máximo gastado en publicidad por semana",
  "FoodB_ads_AUHA_UKTn": "Estado de vigencia",
  "FoodB_images_mWCv_qwcI": "No disponible",
  "FoodB_diagnosis_Package_prices_HhZb": "El precio del combo es mayor al precio máximo",
  "FoodB_IOS_DuJM_XIww": "Ver más",
  "FoodB_app_rJMe_JvWP": "Menú físico: {{DineInSpreadRatio}}% dif.",
  "FoodB_manager_WiiZ_fQTr": "Clics en el anuncio",
  "FoodB_202507_jFRj_JuzW": "Enviar código de verificación",
  "FoodB_manager_tluR_ydNq": "Se cambió con éxito",
  "FoodB_App__CeNy": "No hay combos recomendados",
  "FoodB_202507_gJQz_KNsm": "Por favor, verifica tu número de celular por mensaje de texto para ayudarnos a confirmar que está activo:",
  "FoodB_menu_TLDI_rbsq": "Recolección",
  "Gattaran_System_FPHM_FNhp": "Planes publicitarios",
  "FoodB_manager_gCEg_QRci": "Reinicia los anuncios antes del {{end_data}} para continuar aprovechando la recompensa de la plataforma",
  "FoodB_end_txmi_EUkK": "Creado correctamente",
  "FoodB_guidance_tIZK_FnCu": "20% de dto.",
  "FoodB_images_RTGc_aPGv": "¿Quieres tomar fotos de los productos? ¡Prueba la cámara!",
  "FoodB_end_EXUZ_AybF": "He leído y acepto los",
  "FoodB_images_yEwu_BOgv": "Ver más",
  "FoodB_manager_YJWG_TGEr": "Invierte entre {{amount2}} y {{amount3}}, y obtén una recompensa de la plataforma del {{rate2}}",
  "FoodB_examination_iFla_jDwD": "Uno o más productos no se pueden vender porque sus precios son más altos que los del menú para comer en el lugar. Por favor, revisa la app de {{sys}} para más detalles.",
  "FoodB_ads_zdck_cALt": "Datos de rendimiento",
  "FoodB_manager_OJaX_kWqN": "ROAS",
  "FoodB_manager_zkAd_zMmA": "La cantidad total de usuarios que hicieron clic en el anuncio",
  "FoodB_diagnosis_Store_Gallery_izRn": "Fotos de la tienda",
  "Gattaran_System_MdOu_YQGa": "Presupuesto diario",
  "FoodB_202507_oTId_ZJEY": "Descargar aplicación",
  "FoodB_Packages_WVQT_trjL": "Nombre del modificador",
  "FoodB_edit_GGaD_NBFy": "Precio del producto",
  "FoodB_manager_cAxE_aMhz": "La cantidad de pedidos realizados por usuarios dentro de los siete días posteriores a la visualización del anuncio",
  "soda-b-web-i18n---请输入项目名称": "Ingresa el nombre del producto",
  "FoodB_ads_WAjG_IoqX": "Anuncio",
  "FoodB_ads_mKyB_UXoD": "Términos y Condiciones",
  "FoodB_app_LKsL_pZNy": "Black: {{BlackSpreadRatio}}% de dif.",
  "FoodB_manager_lvpx_Fggm": "Obtén una recompensa de la plataforma del {{rate}} desde el día 8 hasta el final de la promoción",
  "FoodB_combination_dMkH_fHZW": "El monto debe estar entre {{amount1}} y {{amount2}}",
  "Gattaran_System_wrVY_PjDQ": "Nombre del plan",
  "FoodB_manager_Adkb_bXXA": "Una vez que la recompensa finalice el {{date}}, el presupuesto para anuncios volverá a ser de {{b_budget}} por día",
  "FoodB_guidance_LLRv_LmOz": "Los combos con descuentos del 30% o más pueden obtener más visibilidad en la sección “Descuentos deliciosos”.",
  "全部": "Todos",
  "搜索": "Buscar",
  "未搜索到相关菜品": "Sin resultados de búsqueda",
  "暂无菜品": "No hay productos en el menú",
  "搜索结果": "Resultados de búsqueda",
  "菜品名称、加料": "Nombre del producto",
  "下架": "Poner no disponible",
  "上架": "Poner disponible",
  "菜品列表": "Lista de productos",
  "FoodB_0526_CJIS_cGuT": "Store Delivery",
  "FoodB_0526_YWxv_qCMp": "Verify Order Locator Code",
  "FoodB_0526_xxjK_BrKm": "Verify Customer Confirmation Code",
  "FoodB_0526_CWJT_tJDS": "When you meet the customer and hand over the order, ask them to provide a {{number4}}-digit verification code to confirm delivery.",
  "FoodB_0526_ZwcV_xubO": "Complete Delivery",
  "FoodB_0526_pago_jZCL": "Back",
  "FoodB_0526_wOWe_bCYw": "The customer confirmation code entered is unrecognized. Please try again.",
  "FoodB_0526_rIpi_tOxQ": "The order locator code (an {{number3}}-digit number) can be found on the order receipt. It’s used to identify your order and can also serve as an extension number to contact the customer.",
  "FoodB_0526_ALSJ_vOIv": "Verify and Continue",
  "FoodB_0526_ItLx_NtXl": "The locator code entered is unrecognized. Please try again.",
  "FoodB_0526_WpAq_pLIl": "Have you arrived at the delivery location?",
  "FoodB_0526_HUpD_BgTa": "You'll need the order locator code and customer confirmation code to confirm delivery.",
  "FoodB_0526_Ugoi_wHIL": "I have arrived at the location",
  "FoodB_0526_Ohci_xuvI": "Business maintenance is in progress. Please stay tuned",
  "FoodB_0526_LSWB_SqBa": "Locator",
  "FoodB_0526_obJO_XULq": "Step {{number1}}",
  "FoodB_0526_BiXD_Hdyk": "Step {{number2}}",
  "FoodB_0526_RjfK_pdye": "Thank you for your delivery. The order has been confirmed as delivered.",
  "FoodB_notification_hZjl_FphL": "Your item name or description contains invalid words. Please check and try again.",
  "FoodB_dishes_golj_IhqE": "This is a prohibited higher-priced item. Please adjust the price below the controlled price before marking it as available."
}